<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Participants</b-card-title>
    </b-card-header>
    <b-card-body>
      <div class="d-flex align-items-center justify-content-between">
        <div class="my-25 py-3 px-2 cardBorderDash">
          <b-skeleton width="40px" height="20px" v-if="loading"/>
          <span class="h1 font-weight-bolder" v-else>{{
              participatesCount || "0"
            }}</span>
          <br/>
          <small>Participants</small>
        </div>
        <div class="my-25 py-3 px-2 cardBorderDash">
          <b-skeleton width="40px" height="20px" v-if="loading"/>
          <span class="h1 font-weight-bolder" v-else>{{
              newParticipatesCount || "0"
            }}</span>
          <br/>
          <small>New participants</small>
        </div>
      </div>
    </b-card-body>
    <div class="w-100 px-2 pb-2">
      <b-skeleton width="80px" height="20px" v-if="loadingParticipants" />
      <b-avatar-group
        class="d-flex"
        size="34px"
        v-else-if="participants.length"
      >
        <b-avatar
          v-for="(participant, index) in participants"
          :key="index"
          v-b-tooltip.hover.bottom="
            participant.user.data.first_name + ' ' + participant.user.data.last_name
          "
          :src="participant.user.data.avatar"
          class="pull-up"
        />
      </b-avatar-group>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BCardText,
  BButton,
  BAvatarGroup,
  BAvatar,
  VBTooltip,
  BSkeleton,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
    BButton,
    BAvatarGroup,
    BAvatar,
    BSkeleton,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    analytics: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    analytics(val) {
      this.participatesCount = val.participates_count;
      this.newParticipatesCount = val.count_new_participant;
    },
  },
  data() {
    return {
      participatesCount: 0,
      newParticipatesCount: 0,
      participants: [],
      loadingParticipants: false,
    };
  },
  async created() {
    this.loadingParticipants = true;
    await this.getParticipants();
    this.loadingParticipants = false;
  },
  methods: {
    async getParticipants() {
      try {
        const { data } = await this.$http.get(
          `/panel/competitions/${this.$route.params.id}/participants`
        );
        this.participants = data.data;
      } catch (err) {}
    },
  },
};
</script>

<style></style>
